var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _path, _g, _path2, _rect101, _rect102, _rect103, _g2, _rect104, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformSingleLookup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 218,
    viewBox: "0 0 331 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 141.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 164.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 187.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 233.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 279.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 302.5,
    y: 8.70898,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 141.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 164.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 187.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 233.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 279.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 302.5,
    y: 31.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 141.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 164.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 187.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 233.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 279.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 302.5,
    y: 54.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 141.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 164.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 187.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 233.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 279.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 302.5,
    y: 77.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 141.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 164.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 187.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 233.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 279.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 302.5,
    y: 100.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 141.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 164.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 187.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 233.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 279.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 302.5,
    y: 123.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 141.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 164.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 187.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 233.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 279.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 302.5,
    y: 146.709,
    width: 23,
    height: 23,
    stroke: "#E1E4EA"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 171,
    transform: "translate(0 5)",
    fill: "url(#paint0_radial_5295_59540)"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 213,
    transform: "translate(0 5)",
    fill: "url(#paint1_linear_5295_59540)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.096 156.173H38.9063L38.9064 26.24C38.9065 21.9015 38.9071 18.6863 39.1698 16.1695C39.4316 13.6614 39.9492 11.9039 40.9461 10.4615C41.7357 9.31913 42.7256 8.32919 43.868 7.53963C45.3104 6.54275 47.0679 6.02512 49.5759 5.76334C52.0928 5.50064 55.308 5.5 59.6464 5.5H213.886L290.096 62.6453L290.096 156.173Z",
    fill: "white",
    stroke: "#578CDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_5295_59540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.625 63.9766H284.99C286.909 63.9766 287.727 61.5354 286.194 60.3797L217.829 8.82454C216.511 7.83077 214.625 8.77087 214.625 10.4214V61.9766C214.625 63.0811 215.52 63.9766 216.625 63.9766Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.5 8.44141V59.9273C214.5 62.1365 216.291 63.9273 218.5 63.9273H286.753",
    stroke: "#3F7CDB",
    strokeLinecap: "round"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 59.6016,
    y: 30,
    width: 91,
    height: 16,
    rx: 8,
    fill: "#F2F4F7"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 26,
    transform: "translate(23 136.791)",
    fill: "url(#paint2_linear_5295_59540)"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 63.791,
    width: 129,
    height: 16,
    rx: 8,
    fill: "#F2F4F7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5295_59540)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 76.791,
    width: 277,
    height: 60,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5295_59540)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5295_59540)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 88,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#3F7CDB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.9987,
    cy: 106.001,
    rx: 6.66667,
    ry: 6.66667,
    fill: "url(#paint3_linear_5295_59540)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.3346 125.166C72.3346 129.308 72.3346 132.666 59.0013 132.666C45.668 132.666 45.668 129.308 45.668 125.166C45.668 121.024 51.6375 117.666 59.0013 117.666C66.3651 117.666 72.3346 121.024 72.3346 125.166Z",
    fill: "url(#paint4_linear_5295_59540)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 88,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.3509 97.2727H91.6634V103.46C91.6634 104.02 91.5526 104.499 91.331 104.896C91.1122 105.294 90.804 105.598 90.4062 105.808C90.0085 106.016 89.5426 106.119 89.0085 106.119C88.517 106.119 88.0753 106.03 87.6832 105.851C87.294 105.672 86.9858 105.412 86.7585 105.071C86.5341 104.727 86.4219 104.31 86.4219 103.818H87.7301C87.7301 104.06 87.7855 104.268 87.8963 104.445C88.0099 104.621 88.1648 104.759 88.3608 104.858C88.5597 104.955 88.7869 105.003 89.0426 105.003C89.321 105.003 89.5568 104.945 89.75 104.828C89.946 104.709 90.0952 104.534 90.1974 104.304C90.2997 104.074 90.3509 103.793 90.3509 103.46V97.2727ZM96.2347 106.132C95.6211 106.132 95.0856 105.991 94.6282 105.71C94.1708 105.429 93.8157 105.036 93.5629 104.53C93.31 104.024 93.1836 103.433 93.1836 102.757C93.1836 102.078 93.31 101.484 93.5629 100.976C93.8157 100.467 94.1708 100.072 94.6282 99.7912C95.0856 99.5099 95.6211 99.3693 96.2347 99.3693C96.8484 99.3693 97.3839 99.5099 97.8413 99.7912C98.2987 100.072 98.6538 100.467 98.9066 100.976C99.1594 101.484 99.2859 102.078 99.2859 102.757C99.2859 103.433 99.1594 104.024 98.9066 104.53C98.6538 105.036 98.2987 105.429 97.8413 105.71C97.3839 105.991 96.8484 106.132 96.2347 106.132ZM96.239 105.062C96.6367 105.062 96.9663 104.957 97.2276 104.747C97.489 104.537 97.6822 104.257 97.8072 103.908C97.935 103.558 97.9989 103.173 97.9989 102.753C97.9989 102.335 97.935 101.952 97.8072 101.602C97.6822 101.25 97.489 100.967 97.2276 100.754C96.9663 100.541 96.6367 100.435 96.239 100.435C95.8384 100.435 95.506 100.541 95.2418 100.754C94.9805 100.967 94.7859 101.25 94.658 101.602C94.533 101.952 94.4705 102.335 94.4705 102.753C94.4705 103.173 94.533 103.558 94.658 103.908C94.7859 104.257 94.9805 104.537 95.2418 104.747C95.506 104.957 95.8384 105.062 96.239 105.062ZM101.982 102.114V106H100.708V97.2727H101.965V100.52H102.046C102.2 100.168 102.434 99.8878 102.749 99.6804C103.065 99.473 103.477 99.3693 103.985 99.3693C104.434 99.3693 104.826 99.4616 105.161 99.6463C105.499 99.831 105.761 100.107 105.945 100.473C106.133 100.837 106.227 101.291 106.227 101.837V106H104.952V101.99C104.952 101.51 104.829 101.138 104.582 100.874C104.335 100.607 103.991 100.473 103.55 100.473C103.249 100.473 102.979 100.537 102.741 100.665C102.505 100.793 102.319 100.98 102.183 101.227C102.049 101.472 101.982 101.767 101.982 102.114ZM109.201 102.114V106H107.927V99.4545H109.15V100.52H109.231C109.381 100.173 109.617 99.8949 109.938 99.6847C110.262 99.4744 110.67 99.3693 111.161 99.3693C111.607 99.3693 111.998 99.4631 112.333 99.6506C112.668 99.8352 112.928 100.111 113.113 100.477C113.298 100.844 113.39 101.297 113.39 101.837V106H112.116V101.99C112.116 101.516 111.992 101.145 111.745 100.878C111.498 100.608 111.158 100.473 110.727 100.473C110.431 100.473 110.168 100.537 109.938 100.665C109.711 100.793 109.531 100.98 109.397 101.227C109.266 101.472 109.201 101.767 109.201 102.114ZM121.202 106H118.377V97.2727H121.292C122.147 97.2727 122.881 97.4474 123.495 97.7969C124.108 98.1435 124.578 98.642 124.905 99.2926C125.235 99.9403 125.4 100.717 125.4 101.624C125.4 102.533 125.233 103.314 124.901 103.967C124.571 104.621 124.094 105.124 123.469 105.476C122.844 105.825 122.088 106 121.202 106ZM119.694 104.849H121.13C121.794 104.849 122.347 104.724 122.787 104.474C123.228 104.222 123.557 103.857 123.776 103.379C123.995 102.899 124.104 102.314 124.104 101.624C124.104 100.939 123.995 100.358 123.776 99.8807C123.56 99.4034 123.238 99.0412 122.809 98.794C122.38 98.5469 121.847 98.4233 121.211 98.4233H119.694V104.849ZM129.692 106.132C129.078 106.132 128.543 105.991 128.085 105.71C127.628 105.429 127.273 105.036 127.02 104.53C126.767 104.024 126.641 103.433 126.641 102.757C126.641 102.078 126.767 101.484 127.02 100.976C127.273 100.467 127.628 100.072 128.085 99.7912C128.543 99.5099 129.078 99.3693 129.692 99.3693C130.305 99.3693 130.841 99.5099 131.298 99.7912C131.756 100.072 132.111 100.467 132.364 100.976C132.616 101.484 132.743 102.078 132.743 102.757C132.743 103.433 132.616 104.024 132.364 104.53C132.111 105.036 131.756 105.429 131.298 105.71C130.841 105.991 130.305 106.132 129.692 106.132ZM129.696 105.062C130.094 105.062 130.423 104.957 130.685 104.747C130.946 104.537 131.139 104.257 131.264 103.908C131.392 103.558 131.456 103.173 131.456 102.753C131.456 102.335 131.392 101.952 131.264 101.602C131.139 101.25 130.946 100.967 130.685 100.754C130.423 100.541 130.094 100.435 129.696 100.435C129.295 100.435 128.963 100.541 128.699 100.754C128.438 100.967 128.243 101.25 128.115 101.602C127.99 101.952 127.928 102.335 127.928 102.753C127.928 103.173 127.99 103.558 128.115 103.908C128.243 104.257 128.438 104.537 128.699 104.747C128.963 104.957 129.295 105.062 129.696 105.062ZM136.986 106.132C136.341 106.132 135.786 105.994 135.32 105.719C134.857 105.44 134.499 105.05 134.246 104.547C133.996 104.041 133.871 103.449 133.871 102.77C133.871 102.099 133.996 101.509 134.246 100.997C134.499 100.486 134.851 100.087 135.303 99.7997C135.757 99.5128 136.289 99.3693 136.897 99.3693C137.266 99.3693 137.624 99.4304 137.971 99.5526C138.317 99.6747 138.628 99.8665 138.904 100.128C139.179 100.389 139.397 100.729 139.556 101.146C139.715 101.561 139.794 102.065 139.794 102.659V103.111H134.591V102.156H138.546C138.546 101.821 138.478 101.524 138.341 101.266C138.205 101.004 138.013 100.798 137.766 100.648C137.522 100.497 137.235 100.422 136.905 100.422C136.547 100.422 136.235 100.51 135.968 100.686C135.703 100.859 135.499 101.087 135.354 101.368C135.212 101.646 135.141 101.949 135.141 102.276V103.021C135.141 103.459 135.218 103.831 135.371 104.138C135.527 104.445 135.745 104.679 136.023 104.841C136.301 105 136.627 105.08 136.999 105.08C137.24 105.08 137.461 105.045 137.659 104.977C137.858 104.906 138.03 104.801 138.175 104.662C138.32 104.523 138.431 104.351 138.507 104.146L139.713 104.364C139.617 104.719 139.444 105.03 139.194 105.297C138.946 105.561 138.635 105.767 138.26 105.915C137.888 106.06 137.463 106.132 136.986 106.132Z",
    fill: "#4F555F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 114,
    width: 73,
    height: 8,
    rx: 4,
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.477 101.967C282.774 102.227 282.804 102.678 282.545 102.975L275.062 111.546C274.926 111.702 274.73 111.791 274.524 111.791C274.318 111.791 274.121 111.702 273.986 111.546L270.993 108.118C270.733 107.821 270.764 107.37 271.061 107.11C271.358 106.851 271.809 106.881 272.069 107.178L274.524 109.991L281.469 102.036C281.728 101.738 282.179 101.708 282.477 101.967Z",
    fill: "#3FB12C"
  }))), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 77.291,
    width: 276,
    height: 59,
    rx: 11.5,
    stroke: "#3F7CDB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_5295_59540",
    x: 205.625,
    y: 0.417969,
    width: 92.3672,
    height: 75.5586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5295_59540"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5295_59540",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -9,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.891667 0 0 0 0 0.891667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5295_59540"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5295_59540",
    x: 24,
    y: 73.5,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5295_59540"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5295_59540",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5295_59540",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.5 85.5) rotate(90) scale(159.187 308.134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5295_59540",
    x1: 165.5,
    y1: -49.4898,
    x2: 165.5,
    y2: 235.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474771,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5295_59540",
    x1: 144,
    y1: 4.30051,
    x2: 144,
    y2: 22.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5295_59540",
    x1: 57.409,
    y1: 109.998,
    x2: 71.4939,
    y2: 91.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5295_59540",
    x1: 59.0013,
    y1: 117.666,
    x2: 59.0014,
    y2: 129.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5295_59540"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 76.791,
    width: 277,
    height: 60,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5295_59540"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 88,
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformSingleLookup);
export default __webpack_public_path__ + "static/media/perform-single-lookup.a68d6e4f59045671a14474552e4cc3d7.svg";
export { ForwardRef as ReactComponent };